import { render, staticRenderFns } from "./examinationArrangementAdd.vue?vue&type=template&id=502a9c2a&scoped=true"
import script from "./examinationArrangementAdd.vue?vue&type=script&lang=js"
export * from "./examinationArrangementAdd.vue?vue&type=script&lang=js"
import style0 from "./examinationArrangementAdd.vue?vue&type=style&index=0&id=502a9c2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502a9c2a",
  null
  
)

export default component.exports